function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:10;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:5;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M295.4,228.7c-6.5,0-11.8-5.3-11.8-11.8v-47.2c0-6.5,5.3-11.8,11.8-11.8h96.7c-31.5-43.1-82.5-71.2-140-71.2 c-95.8,0-173.2,77.5-173.2,173.2s77.5,173.2,173.2,173.2c44.1,0,84.2-16.4,114.8-43.4c4.6-4.1,11.7-3.8,16.1,0.5l33.5,33.5 c4.8,4.8,4.5,12.6-0.5,17.1C372.6,480.1,315.2,504,252.1,504C117.4,504,8.3,395.1,8,260.4C7.7,125.7,115.6,16.9,250.3,15.9 c72.7-0.5,138.2,30.8,183.2,80.8V19.8c0-6.5,5.3-11.8,11.8-11.8h47.2c6.5,0,11.8,5.3,11.8,11.8v197.1c0,6.5-5.3,11.8-11.8,11.8 H295.4L295.4,228.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M154.4,355.8v-8.3l10.6-10.3c25.5-24.2,37-37.1,37.1-52.1c0-10.1-4.9-19.5-19.8-19.5c-9,0-16.6,4.6-21.2,8.4 l-4.3-9.5c6.9-5.8,16.7-10.1,28.2-10.1c21.5,0,30.5,14.7,30.5,29c0,18.4-13.3,33.3-34.3,53.5l-8,7.4v0.3H218v11.2H154.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M243.6,281.6l10.6,15.9c2.8,4.1,5.1,8,7.5,12.1h0.5c2.5-4.4,4.9-8.3,7.4-12.3l10.4-15.8h14.6l-25.3,35.9 l26.1,38.3H280L269.1,339c-2.9-4.3-5.4-8.4-8-12.9h-0.3c-2.5,4.4-5.1,8.4-7.8,12.9l-10.7,16.7h-14.9l26.4-37.9l-25.1-36.3 L243.6,281.6L243.6,281.6z"
}));

function SvgIconRotateRight2X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateRight2X);
export default __webpack_public_path__ + "static/media/icon_rotate_right-2x.eb6f053a.svg";
export { ForwardRef as ReactComponent };